// Page size and column count have to move together across the Select Image tabs, or the last row renders short.
export const GRID_PAGE_SIZE = 18;
export const GRID_COLUMNS = 6;
export const GRID_COLUMNS_MD = 3;
